var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssignTags = function SvgAssignTags(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137.204,
    height: 121.845,
    viewBox: "0 0 137.204 121.845",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.24,
    d: "M105.985,11.307C93.817.357,68.387-1.964,55.177,4.8,48.372,8.335,44.3,17.017,39.394,31.088c-4.285,12.289-8.691,31.044-6.953,43.7,2.138-2.607,4.441-6.084,6.675-9.395,5.588-8.4,8.908-13.115,11.933-11.811,3.381,1.46,1.669,7.292-.313,14.053a46.356,46.356,0,0,0-1.886,7.822,13.565,13.565,0,0,0,.661,5.006,27.665,27.665,0,0,1,.869,11.107c11.3,2.79,23.692,1.921,29.037-.139,21.023-7.309,34.538-45.324,34.538-45.324S121,24.074,105.985,11.307Z",
    transform: "translate(-4.196 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.709 8.164)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M85.29,47.055l-15.9-33.808A6.953,6.953,0,0,0,60.138,9.9L5.959,35.409A6.953,6.953,0,0,0,2.63,44.665L7.349,54.695a3.315,3.315,0,0,1,.374-.148,1.312,1.312,0,0,1,1.625.7c.052.122,5.562,12.419,10.1,19.989,1.243,2.312,2.607,3.615,4.05,3.807a4.432,4.432,0,0,0,3.416-1.347c2.564-2.659,5.449-6.953,8.248-11.185,5.606-8.439,8.926-13.15,11.95-11.846,3.381,1.46-.046,7.292-2.028,14.053-.478,1.625.75,3.285.368,4.763l36.5-17.165a6.953,6.953,0,0,0,3.337-9.256Z",
    transform: "translate(-1.966 -9.244)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#c12714",
    d: "M38.141,59.964a2.917,2.917,0,1,1-3.868-1.393A2.907,2.907,0,0,1,38.141,59.964Z",
    transform: "translate(26.183 -34.785)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f31c02",
    d: "M39.814,76.532l6.125-10.449s3.342-4.245,5.736-3.357,1.236,5.392,1.236,5.392l-4.33,12.95Z",
    transform: "translate(-5.212 -8.064)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#f7f7f7",
    d: "M50.87,122.528l-6.848-15.583a24.169,24.169,0,0,0,1.738-4.267,1.048,1.048,0,0,0,0-.148c1.243-7.9.278-11.525-.5-14.436a13.568,13.568,0,0,1-.661-5.006,46.366,46.366,0,0,1,1.886-7.822c1.982-6.762,3.694-12.593.313-14.053-3.024-1.295-6.344,3.407-11.95,11.811-2.746,4.189-5.632,8.526-8.2,11.22a4.432,4.432,0,0,1-3.416,1.417c-1.417-.191-2.807-1.495-4.05-3.807-4.537-7.6-10.047-19.9-10.1-19.989a1.312,1.312,0,0,0-1.625-.7A11.968,11.968,0,0,0,0,72.459C0,78.751,20.1,124.7,22.39,129.915a1.3,1.3,0,0,0,1.191.782,1.227,1.227,0,0,0,.521-.113,1.3,1.3,0,0,0,.669-1.738C15.863,108.579,2.609,76.8,2.609,72.459a9.291,9.291,0,0,1,4.65-8.378c1.53,3.337,5.919,12.758,9.664,19.025,1.651,3.068,3.659,4.789,5.962,5.1a6.892,6.892,0,0,0,5.649-2.225c2.72-2.825,5.684-7.257,8.543-11.55,2.72-4.085,6.51-11.968,8.743-10.855s-.869,7.822-1.738,10.916a48.317,48.317,0,0,0-1.99,8.352,16.167,16.167,0,0,0,.747,5.884c.747,2.807,1.59,5.979.452,13.289-1.234,4.346-5.554,10.664-8,11.646a1.312,1.312,0,0,0,.982,2.425c2.034-.869,4.345-3.476,6.179-6.379l6.084,13.836a1.3,1.3,0,0,0,1.191.773,1.439,1.439,0,0,0,.53-.1A1.3,1.3,0,0,0,50.87,122.528Z",
    transform: "translate(0 -7.854)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.088 68.846)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "#f7f7f7",
    fillRule: "evenodd",
    d: "M123.74,132.809a3.738,3.738,0,1,0-3.746-3.738A3.742,3.742,0,0,0,123.74,132.809Z",
    transform: "translate(-94.795 -85.122)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#f7f7f7",
    d: "M148.506,91.453a38.86,38.86,0,0,0-56.9,0,2.268,2.268,0,0,0,3.321,3.089,34.314,34.314,0,0,1,50.255,0,2.268,2.268,0,0,0,3.321-3.089Z",
    transform: "translate(-91 -79.065)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.755,
    fill: "#f7f7f7",
    fillRule: "evenodd",
    d: "M141.419,102.788a27.823,27.823,0,0,0-40.226,0,2.268,2.268,0,0,0,3.223,3.191,23.279,23.279,0,0,1,33.781,0,2.268,2.268,0,1,0,3.223-3.192Z",
    transform: "translate(-92.248 -81.045)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.605,
    fill: "#f7f7f7",
    fillRule: "evenodd",
    d: "M133.668,114.166a16.4,16.4,0,0,0-11.049-4.734h-.167a16.4,16.4,0,0,0-11.049,4.734,2.268,2.268,0,0,0,3.2,3.219,11.865,11.865,0,0,1,7.853-3.422h.167a11.865,11.865,0,0,1,7.853,3.422,2.268,2.268,0,1,0,3.2-3.219Z",
    transform: "translate(-93.583 -83.04)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M123.143,73.587l-3.857-4.2L118,70.791l5.143,5.593L134.165,64.4,132.879,63Z",
    transform: "translate(-15.162 -12.847)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssignTags, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assign-tags.429e6063.svg";
export { ForwardRef as ReactComponent };